import Store from "./stores/RegisterUserStore";
import Event from "./events/RegisterUserEvent";
import "materialize-css";

let store = new Store();
let event = new Event(store);

$(document).ready(() => {
    $('#mail').focus()
});
document.addEventListener('DOMContentLoaded', function() {
    let elems = document.querySelectorAll('.modal');
    let instances = M.Modal.init(elems, {});
});